<template>
  <div>
    <div class="league-hat">
      <active-button
        class="league-button"
        :title="league.name"
        @click="$router.push(`/prematch/sport/${sport}/league/${league.id}`)"
      >
        <div class="league-name ellipsis">{{ league.name }}</div>
      </active-button>
      <!--icon-button @click="open = !open">
        <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button-->
    </div>
    <div class="list" :class="open ? 'open' : ''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'

export default {
  components: {
    ActiveButton,
    IconButton,
    ArrowIcon
  },
  props: {
    league: Object,
    sport: Number
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.league-hat { display: flex; }
.league-hat:last-child { margin-bottom: 2px; }
.league-hat .arrow-icon { font-size: 16px; }
.league-button { display: flex; height: 40px; line-height: 40px; }
.league-name { padding-left: 5px; width: 225px; }
.list { background: rgba(255, 255, 255, .05); display: none; }
.list.open { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/sports/menu/League.vue